import React from 'react';
import { Modal, View, Text, TouchableOpacity, StyleSheet } from 'react-native';
import { useNavigation } from '@react-navigation/native';
import { AppRoutes } from '../../../../navigation/Routes.types';
import { Colors } from '../../../../constants/Colors';
import ButtonComponent from '../../../../components/ButtonComponent/ButtonComponent';

interface ExtendedTermsModalProps {
  visible: boolean;
  onRequestClose: () => void;
  onConfirm: () => void;
  remaining: number;
  days: number;
}

const ExtendedTermsModal: React.FC<ExtendedTermsModalProps> = ({ visible, onRequestClose,onConfirm, remaining, days }) => {
  const { navigate } = useNavigation();

  return (
    <Modal
      animationType="slide"
      transparent={true}
      visible={visible}
      onRequestClose={onRequestClose}
    >
      <View style={styles.overlay}>
        <View style={styles.modalContainer}>
          <Text style={styles.modalHighlight}>
            Faltam só {remaining.toLocaleString('pt-BR', {
              style: 'currency',
              currency: 'BRL',
            })} para garantir {days} dias para pagar!
          </Text>
          <Text style={styles.modalText}>
            Adicione mais itens ao seu pedido e aproveite essa condição especial.
          </Text>

          <View style={styles.buttonContainer}>
            <ButtonComponent
              title='Finalizar pedido'
              outlined
              onPress={onConfirm}
            />
            <ButtonComponent
              title='Adicionar mais itens'
              onPress={() => {
                onRequestClose();
                (navigate as any)(AppRoutes.MAIN_TAB_SCREEN, { screen: 'Home' });
              }}
            />
          </View>
        </View>
      </View>
    </Modal>
  );
};

const styles = StyleSheet.create({
  overlay: {
    flex: 1,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    justifyContent: 'center',
    alignItems: 'center',
  },
  modalContainer: {
    width: '80%',
    backgroundColor: '#fff',
    borderRadius: 10,
    padding: 20,
    alignItems: 'center',
  },
  modalText: {
    fontSize: 16,
    color: '#333',
    textAlign: 'center',
    marginBottom: 12,
    fontWeight: '500',
  },

  modalHighlight: {
    fontSize: 18,
    fontWeight: 'bold',
    color: Colors.RedPallete.red,
    marginBottom: 8,
  },

  buttonContainer: {
    flexDirection: 'column',
    gap: 10,
    justifyContent: 'center',
    width: '100%',
  },
  button: {
    flex: 1,
    padding: 12,
    borderRadius: 8,
    alignItems: 'center',
    marginHorizontal: 5,
  },
  continueButton: {
    backgroundColor: Colors.GreenPallete.greenOne,
  },
  addButton: {
    backgroundColor: Colors.RedPallete.red,
  },
  buttonText: {
    color: '#fff',
    fontSize: 14,
    fontWeight: 'bold',
  },
});

export default ExtendedTermsModal;